import { HttpEventType } from "@angular/common/http";
import { Component } from "@angular/core";
import { CrudComponent } from "src/app/components/shared/cruds/crud.component";
import { Condition } from "src/app/models/custom-types";
import { FilterEvent } from "src/app/models/filter";
import { ListColumn } from "src/app/models/list-columns.model";
import { UnidadesDTO } from "src/app/models/unidades.dto";
import { AlertasSwalService } from "src/app/services/alerts.service";
import { LayoutsService } from "src/app/services/layouts.service";
import { Filter } from "src/app/shared/classes/filter";
import { UnidadesService } from "./unidades.service";

@Component({
  selector: "app-unidades",
  templateUrl: "./unidades.component.html",
  styles: [],
})
export class UnidadesComponent extends CrudComponent<UnidadesDTO> {
  columnId: string = "IdUnidad";
  public columns: ListColumn[] = [
    {
      name: "# Control",
      property: "NoControl",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Modelo",
      property: "Modelo",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Placas",
      property: "Placas",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Serie",
      property: "Serie",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Tipo Unidad",
      property: "TipoUnidad",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Empresa",
      property: "Empresa",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "actions",
      property: "actions",
      visible: true,
      isModelProperty: false,
    },
  ];
  filtro: string = "";
  inactivos: boolean = false;
  realdata: UnidadesDTO[];

  constructor(
    public service: UnidadesService,
    private layoutService: LayoutsService,
    public alerts: AlertasSwalService
  ) {
    super(service, alerts);
  }

  ngOnInit(): void {
    this.loadRecords();
    this.layoutService.changeHeader("Listado de Unidades");
    this.filter = new Filter<UnidadesDTO>(this.conditions, this.columns, true);
    this.filter.setColumnActive(this.columnActive);
  }

  loadRecords() {
    this.service.get().subscribe(
      (resultData) => {
        this.realdata = resultData.sort((a, b) => a.NoControl - b.NoControl);
        this.filter.setDataTable(this.realdata, this.tableComp);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }

  //#region Filter

  public filter: Filter<UnidadesDTO>;
  public conditions: Condition<UnidadesDTO> = {
    NoControl: (o, f) => o.NoControl.toLocaleLowerCase().indexOf(f) > -1,
    Modelo: (o, f) =>
      (o.Modelo ?? "").toString().toLocaleLowerCase().indexOf(f) > -1,
    Placas: (o, f) =>
      (o.Placas ?? "").toString().toLocaleLowerCase().indexOf(f) > -1,
    Serie: (o, f) =>
      (o.Serie ?? "").toString().toLocaleLowerCase().indexOf(f) > -1,
    TipoUnidad: (o, f) =>
      (o.TipoUnidad ?? "").toString().toLocaleLowerCase().indexOf(f) > -1,
    Empresa: (o, f) =>
      (o.Empresa ?? "").toString().toLocaleLowerCase().indexOf(f) > -1,
  };

  filterdata(e: FilterEvent) {
    this.filter.filterdata(e, this.realdata, this.tableComp);
  }

  //#endregion Filter

  saveForm(e: { mode: string; value: UnidadesDTO; poliza: File }) {
    if (e.mode == "create") {
      this.guardarWithPoliza(e.value, e.poliza);
    } else if (e.mode == "update") {
      this.actualizarWithPoliza(e.value, e.poliza);
    }
  }

  guardarWithPoliza(row: UnidadesDTO, poliza: File) {
    this.service.add(row).subscribe(
      async () => {
        await this.alerts.correcta("Creado", "Accion realizada correctamente" + + (poliza ? "Poliza se guardara a continuacion" : ""));
        if (poliza) {
          this.savePoliza(row.IdUnidad, poliza);
        }

        this.formulario.setStanby();
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      },
      () => {
        this.formulario.setWaiting(false);
      }
    );
  }
  savePoliza(IdUnidad: string, poliza: File) {
    this.service.polizaAdd(IdUnidad, poliza).subscribe(
      (event) => {
        if (event.type === HttpEventType.Response) {
          if (event.ok) {
            this.alerts.correcta("Correcto", "Poliza guardada");
          } else {
            this.alerts.error("Error", "Ocurrio un error al guardar poliza");
          }
        }
      },
      (err) => {
        this.alerts.error("Error", err.error.Message);
      }
    );
  }
  actualizarWithPoliza(row: UnidadesDTO, poliza: File) {
    this.service.update(row).subscribe(
      async () => {
       await  this.alerts.correcta("Actualizado", "Accion realizada correctamente. " + (poliza ? "Poliza se guardara a continuacion" : ""));
        if (poliza) {
          this.savePoliza(row.IdUnidad, poliza);
        }
        this.formulario.setStanby();
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }
}
